import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from '../../../../i18next';

import {
    loadChargeTypeMappings,
    updateChargeTypeMappings,
    loadPosChargeTypes,
    importPosChargeTypes
} from '../../../../actions/index';
import MappingTypes from './MappingTypes';

class ChargeTypeMappingScreen extends Component {
    constructor(props) {
        super(props);

        this.updateChargeTypeMappings = this.updateChargeTypeMappings.bind(this);
        this.importAllPosChargeTypes = this.importAllPosChargeTypes.bind(this);
    }

    componentDidMount() {
        const { id } = this.props.match.params;

        this.props.loadChargeTypeMappings(id);
        this.props.loadPosChargeTypes(id);
    }

    updateChargeTypeMappings(mappingTypes) {
        const { id } = this.props.match.params;

        this.props.updateChargeTypeMappings(this.transformMappingTypes(mappingTypes), id);
    }

    transformMappingTypes(mappingTypes) {
        const updatedMappings = [];

        mappingTypes.map(mapping => {
            const currentMapping = {
                id: mapping.id,
                chargeType: {
                    id: mapping.mappingType.id,
                    value: mapping.mappingType.value
                },
                posChargeType: {
                    id: mapping.posType.id,
                    value: mapping.posType.value,
                    posId: mapping.posType.posId
                }
            }
            updatedMappings.push(currentMapping);
        });

        return updatedMappings;
    }

    importAllPosChargeTypes() {
        const { id } = this.props.match.params;
        this.props.importPosChargeTypes(id);
    }

    render() {
        const translationData = {
            heading: i18n.t('screens:restaurantsMainContainer.chargetype'),
            firstLabel: i18n.t('screens:chargeTypeMappingScreen.chargeType'),
            secondLabel: i18n.t('screens:chargeTypeMappingScreen.posChargeType')
        }

        return (
            <MappingTypes
                params={this.props.match.params}
                mappingTypes={this.props.chargeTypeMappings}
                update={this.updateChargeTypeMappings}
                posTypes={this.props.chargePosTypes}
                import={this.importAllPosChargeTypes}
                posSettings={this.props.posSettings}
                translations={translationData}
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        restaurants: state.restaurants,
        chargeTypeMappings: state.chargeTypeMappings,
        chargePosTypes: state.chargePosTypes,
        posSettings: state.posSettings
    };
};

export default connect(
    mapStateToProps,
    {
        loadChargeTypeMappings,
        updateChargeTypeMappings,
        loadPosChargeTypes,
        importPosChargeTypes
    }
)(ChargeTypeMappingScreen);


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/pos/ChargeTypeMappingScreen.js